<template>
	<div class="contact-us-details">
    <h2>{{ contactDetailsTitle }}</h2>
		<ul class="details-list">
			<li v-for="item in
          contactDetailItems"
          :key="item.title"
          class="details-list__item">
				{{ item.desc }}
			</li>
		</ul>
    <h2>Wedding Questionnaire</h2>
    <p>
      Download our Wedding Questionnaire:
      <a href="https://s3.amazonaws.com/berries.and.blooms.assets/BB_Wedding_Questionare_2018.pdf"
         target="_blank">
      Click here
      </a>
    </p>
    <p class="mb-5">Download our Events Questionnaire:
      <a href="https://s3.amazonaws.com/berries.and.blooms.assets/BB_Event_Questionare_2018.pdf"
        target="_blank">
        Click here
      </a>
    </p>
		<h2>Find us on social media</h2>
		<ul class="details-socials-icons"
        itemscope
        itemtype="http://schema.org/Organization">
      <link itemprop="url" href="http://berriesandblooms.co.za/">
      <li v-for="(item, index) in socialMediaItems"
          :key="index"
          itemprop="sameAs">
        <a :href="item.link"
           target="_blank"
           rel="noopener">
          <img :src="item.imageSrc" :alt="item.altTag">
        </a>
      </li>
		</ul>
  </div>
</template>

<script>
export default {
  name: 'ContactUsForm',
  data: () => ({
    contactDetailsTitle: 'Our Contact Details',
    contactDetailItems: [
      { title: 'contact', desc: '(+ 27) 83 688 9772' },
      { title: 'email', desc: 'info@berriesandblooms.co.za' },
    ],
    /* eslint-disable */
    socialMediaItems: [
      {
        link: 'https://www.facebook.com/berriesandbloomssa/',
        altTag: 'Facebook',
        imageSrc: require('@/assets/icon_facebook.svg'),
      },
      {
        link: 'https://www.instagram.com/berries.and.blooms',
        altTag: 'Instagram',
        imageSrc: require('@/assets/icon_instagram.svg'),
      },
    ],
  }),
}
</script>
